import script from "./StockDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StockDataTable.vue?vue&type=script&setup=true&lang=js"

import "./StockDataTable.vue?vue&type=style&index=0&id=6e9c01a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9c01a6"]])

export default __exports__